import React from "react";
import { useDispatch } from "react-redux";
import {
  actionGetGrupoMonitoramento,
  actionSelectGrupoMonitoramento,
} from "../../features/grupos-de-monitoramento/slices";
import factoryOptionsFields from "../../helpers/factory-fields";
import { useAppSelector } from "../../hooks/useAppSelector";
import Select from "./../Select";

const FilterGruposMonitoria = ({ cb }) => {
  const dispatch = useDispatch();

  const handleChange = ({ target: { value } }: any) => {
    cb(Number(value));
    dispatch(actionSelectGrupoMonitoramento(Number(value)));
  };

  const { data, status, grupoMonitoramentoSelected } = useAppSelector(
    (state) => state.getGrupoMonitoramento
  );

  React.useEffect(() => {
    dispatch(actionGetGrupoMonitoramento());
  }, [dispatch]);

  if (status === "loading") {
    return <strong>Carregando filtros...</strong>;
  }

  if (!data) return null;

  return (
    <Select
      options={factoryOptionsFields.grupoMonitoramento(data)}
      label="Grupos de monitoramento"
      name="idGrupoDeMonitoramento"
      onChange={handleChange}
      value={grupoMonitoramentoSelected?.id || ""}
      size="sm"
    />
  );
};

export default FilterGruposMonitoria;
